/** Root of every notification query, so invalidating it refreshes the badge and all lists. */
export const NOTIFICATIONS_QUERY_KEY = ['notifications'] as const

/** The leading dot is how Echo addresses a name set by the backend's `broadcastAs()`. */
export const NOTIFICATION_CREATED_EVENT = '.notification.created'

/** The user's own private channel; Echo adds the `private-` prefix. */
export function notificationChannel(userId: string): string {
  return `users.${userId}`
}
